import { useContext, useState } from 'react';
import { UploadFileContainer } from '../style/BriefInputStyle';
import DragAndDrop3 from './3.1.DrangAndDrop';
import SelectedFilesList3 from './3.2.SelectedFilesList';
import { saveFiletoS3 } from './saveFiletoS3';
import { ACdetails, useCampaignContext } from 'context/CampaignContext';
import { DeleteStoredQueryMutation, Environment, FlowchartCampaignStatus } from 'API';
import APIContext from 'context/APIContext';
import { env } from 'process';
import { QueryInfo } from '../Brief';
import { API } from 'aws-amplify';
import { deleteStoredQuery } from 'graphql/mutations';
import { useTab } from 'customHooks/useParameters';
import { useCheckRollbackStatus } from 'customHooks/useCheckRollbackStatus';
import { useUpdateCampaignStatus } from '../CustomHook/useUpdateCampaignStatus';
import { useFetchPlanData } from '../../Plan/useFetchPlanData';
import { useLoggingActivity } from 'customHooks/useLogging';

type Props = {
  uploadNewFile(id: string, position: string, file: File): void;
  uploadedFiles: QueryInfo[];
  openFile: (queryInfo: QueryInfo) => void;
  editBrief: boolean;
  setUploadedFiles: (files: QueryInfo[]) => void;
  position: string;
};

export const colorsForIcon: { [key: string]: string } = {
  PDF: 'rgb(255, 204, 123)',
  PNG: 'rgb(152, 205, 255)',
  JPG: '#b3fbf4',
  DOCX: '#babffe',
  TXT: '#e6fcac',
  ZIP: '#ffb0a2',
};

const UploadFile3 = (props: Props) => {
  // const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  console.log('POSITION', props.position);
  const { getEnvironment } = useContext(APIContext);
  const logActivity = useLoggingActivity();
  const selectedFiles = props.uploadedFiles;
  const { campaignList, setPermanentCampaignList, permanentCampaignList, activeCampaign } = useCampaignContext();
  const [rollbackStatus] = useCheckRollbackStatus(activeCampaign);
  const [UpdateCampaign] = useUpdateCampaignStatus();

  const [tab] = useTab();

  const addFile = async (files: FileList) => {
    if (files && files.length > 0) {
      const fileList = Array.from(files) as File[];
      //  setSelectedFiles([...selectedFiles, ...fileList]);
      // const position = "Brief"

      if (activeCampaign) {
        const initialIndex = selectedFiles.length;
        fileList.forEach((f, index) => {
          const saved = saveFiletoS3(
            f,
            initialIndex + index + 1,
            activeCampaign.campaignId,
            activeCampaign.ClientCode,
            activeCampaign.ClientCountry,
            getEnvironment,
            props.position,
          );

          props.uploadNewFile(saved.id, saved.position, f);
        });

        // Log the file upload activity
        if (props.position === 'Plan') {
          logActivity({
            action: 'FILE_UPLOAD_PLAN',
          }).catch(console.error);
        }
        if (props.position === 'Brief') {
          logActivity({
            action: 'BRIEFED',
          }).catch(console.error);
        }
      }
    }
  };

  async function removeFromS3(position: string) {
    try {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const deleteStoredQ = (await API.graphql({
        query: deleteStoredQuery,
        variables: {
          campaign_id: activeCampaign?.campaignId?.toString(),
          Environment: getEnvironment,
          placeholder: position,
        },
        authMode: 'AMAZON_COGNITO_USER_POOLS',
      })) as { data: DeleteStoredQueryMutation };
    } catch (e) {
      console.log('ERROR  DELETING QUERY', e);
    }
  }

  const removeFile = (queryInfo: QueryInfo) => {
    removeFromS3(queryInfo.position);
    props.setUploadedFiles(selectedFiles.filter((f) => f.id !== queryInfo.id));
    // TODO if there is no files left or if there is no items in a row rollback campaign
    console.log(props.uploadedFiles.length);
    if (props.uploadedFiles.length === 1 && !rollbackStatus?.hasPlan) {
      if (activeCampaign?.status === 'PLANNING_DONE' || activeCampaign?.status === 'PLANNING_STARTED') {
        const rollbackTo = rollbackStatus?.hasBrief ? 'BRIEF_COMPLETED' : 'CREATED';

        UpdateCampaign(activeCampaign, FlowchartCampaignStatus[rollbackTo]);

        const campaign = permanentCampaignList?.find(
          (campaign: any) => campaign.campaignId === activeCampaign?.campaignId,
        );
        const newCampaign = {
          ...campaign,
          status: FlowchartCampaignStatus[rollbackTo],
        } as ACdetails;

        const newCampaignList = permanentCampaignList?.map((campaign: ACdetails) => {
          if (campaign?.campaignId === activeCampaign?.campaignId) {
            return newCampaign;
          } else {
            return campaign;
          }
        }) as ACdetails[];
        setPermanentCampaignList(newCampaignList);
      }
    }
  };

  const removeAllFiles = () => {
    // setSelectedFiles([]);
  };

  const tabPlanNoAuthorized = tab === 'plan' && !activeCampaign?.authorized;

  return (
    <div>
      <UploadFileContainer>
        {!tabPlanNoAuthorized && <DragAndDrop3 selectedFiles={selectedFiles} addFile={addFile} />}
        {selectedFiles.length > 0 && (
          <SelectedFilesList3
            selectedFiles={selectedFiles}
            editBrief={props.editBrief}
            removeAllFiles={removeAllFiles}
            colorsForIcon={colorsForIcon}
            openFile={props.openFile}
            removeFile={removeFile}
            addFile={addFile}
          />
        )}
      </UploadFileContainer>
    </div>
  );
};

export default UploadFile3;
